import { localAPI } from "../api/local";
import history from "../config/history";
import { errorHandler } from "./errorHandler";
import * as paymentConstants from "../constants/paymentConstants";

export const initiatePayment = (plan) => async (dispatch) => {
  try {
    await dispatch({
      type: paymentConstants.PAYMENT_INITIATE_REQUEST,
      payload: {
        plan,
      },
    });
    const data = await localAPI.post("/api/razorpay", { plan });

    await dispatch({
      type: paymentConstants.PAYMENT_INITIATE_SUCCESS,
      payload: {
        data: data.data,
      },
    });
  } catch (error) {
    errorHandler(
      paymentConstants.PAYMENT_INITIATE_FAIL,
      error,
      false,
      dispatch
    );
  }
};

export const initiateOneTimePayment = (plan) => async (dispatch) => {
  try {
    await dispatch({
      type: paymentConstants.PAYMENT_INITIATE_REQUEST,
      payload: {
        plan,
      },
    });
    const data = await localAPI.post("/api/razorpay/onetime", { plan });

    await dispatch({
      type: paymentConstants.PAYMENT_INITIATE_SUCCESS,
      payload: {
        data: data.data,
      },
    });
  } catch (error) {
    errorHandler(
      paymentConstants.PAYMENT_INITIATE_FAIL,
      error,
      false,
      dispatch
    );
  }
};

export const verifyPayment = (response) => async (dispatch) => {
  // failure response (payment failed)

  if (response?.code) {
    dispatch({
      type: paymentConstants.PAYMENT_VERIFY_FAIL,
    });

    history.push("/confirmation/pricing/fail");
  } else {
    try {
      await dispatch({
        type: paymentConstants.PAYMENT_VERIFY_REQUEST,
      });

      const data = await localAPI.post("/api/razorpay/verify", {
        paymentId: response.razorpay_payment_id,
        subscriptionId: response?.razorpay_subscription_id,
        orderId: response?.razorpay_order_id,
        signature: response.razorpay_signature,
      });

      if(data?.data?.success) {
        history.push('/confirmation/pricing/success')
      }

      await dispatch({
        type: paymentConstants.PAYMENT_VERIFY_SUCCESS
      });
    } catch (error) {
      errorHandler(
        paymentConstants.PAYMENT_VERIFY_FAIL,
        error,
        false,
        dispatch,
        () => {
          history.push(`/confirmation/pricing/progress`);
        }
      );
    }
  }
};

export const cancelSubscription = () => async (dispatch) => {
  try {
    await dispatch({
      type: paymentConstants.SUBSCRIPTION_CANCEL_REQUEST
    });
    const data = await localAPI.get("/api/razorpay/cancel");

    await dispatch({
      type: paymentConstants.SUBSCRIPTION_CANCEL_SUCCESS,
      payload: {
        data: data.data,
      },
    });

    history.push("/confirmation/cancellation/success");
  } catch (error) {
    errorHandler(
      paymentConstants.SUBSCRIPTION_CANCEL_FAIL,
      error,
      false,
      dispatch,
      (type, errMessage) => {
        history.push(`/confirmation/cancellation/fail?message=${errMessage}`);
      }
    );
  }
};

export const pauseSubscription = (plan) => async (dispatch) => {
  try {
    await dispatch({
      type: paymentConstants.SUBSCRIPTION_CANCEL_REQUEST,
      payload: {
        plan,
      },
    });
    const data = await localAPI.post("/api/razorpay/pause", { plan });

    await dispatch({
      type: paymentConstants.SUBSCRIPTION_CANCEL_SUCCESS,
      payload: {
        data: data.data,
      },
    });
  } catch (error) {
    errorHandler(
      paymentConstants.SUBSCRIPTION_CANCEL_FAIL,
      error,
      false,
      dispatch
    );
  }
};

export const resumeSubscription = (plan) => async (dispatch) => {
  try {
    await dispatch({
      type: paymentConstants.SUBSCRIPTION_CANCEL_REQUEST,
      payload: {
        plan,
      },
    });
    const data = await localAPI.post("/api/razorpay/resume", { plan });

    await dispatch({
      type: paymentConstants.SUBSCRIPTION_CANCEL_SUCCESS,
      payload: {
        data: data.data,
      },
    });
  } catch (error) {
    errorHandler(
      paymentConstants.SUBSCRIPTION_CANCEL_FAIL,
      error,
      false,
      dispatch
    );
  }
};
